import React, {useState, useEffect} from 'react';
import './Style.css';

const QuantityInputFontAwesome = (props)=> {
  const [quantity,setQuantity] = useState(props.value);
  const [step,setStep] = useState(props?.step??1);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setQuantity(props.value);
    setStep(props.step);
    setLoading(false);
  }, [props.value,props.step]);

  useEffect(() => {
    const debounceTimeout = setTimeout(() => {
      if( props.item.quantity!==quantity ){
        setLoading(true);
        if( quantity===0 ){
          props.quantityRemove();
        }
        else{
          props.quantityChanged(quantity);
        }
      }
    }, 700);
    return () => clearTimeout(debounceTimeout);
  },[quantity,props]);

  const changed = (value)=>{
    setQuantity(value);
  };

  const blur = () =>{
    setQuantity(quantity);
  };

  const decrease = () =>{
    let new_quantity = parseInt(quantity);
    new_quantity-=step;
    if( new_quantity<0 ) new_quantity = 0;

    setQuantity(new_quantity);
  };

  const increase = () =>{
    let new_quantity = parseInt(quantity);
    new_quantity+=step;
    setQuantity(new_quantity);
  };

  return (
    <div className={props.classNameContainer??"quantity_container"}>
      <button className={props.classNameButtonMinus??"icon minus"} disabled={loading} onClick={e=>decrease()}><i className="fa fa-minus" aria-hidden="true"></i></button>
      <input type="text" name="quantity" className={props.classNameInput??"quantity"}
        inputMode="numeric"
        disabled={loading||step>1}
        onKeyPress={(event) => {if (!/[0-9]/.test(event.key)) {event.preventDefault();}}}
        value={quantity}
        onChange={e=>changed(e.target.value)}
        onBlur={e=>blur()}
      />
      <button className={props.classNameButtonPlus??"icon plus"} disabled={loading} onClick={e=>increase()}><i className="fa fa-plus" aria-hidden="true"></i></button>
    </div>
  )
}
export default QuantityInputFontAwesome;